import {eventChannel, END} from 'redux-saga';
import {call, cancel, cancelled, fork, put, take} from 'redux-saga/effects';
import config from 'config';
import * as constants from '../constants';
import {propertyValueUpdate} from '../actions/propertyActions';
import {wsConnected, wsConnecting, wsDisconnected} from '../actions/wsActions';

function createEventChannel() {
    return eventChannel((emitter) => {
        let canceled = false;
        let ws;

        function createWs() {
            emitter(wsConnecting());
            ws = new WebSocket(config.swarmWsUrl);
            ws.onopen = () => {
                emitter(wsConnected());
            };
            ws.onmessage = (e) => {
                const data = JSON.parse(e.data);
                switch (data.type) {
                    case 'PV':
                        return emitter(propertyValueUpdate(data.payload));
                }
            };
            ws.onclose = () => {
                ws && emitter(wsDisconnected());
                if (canceled === false) {
                    ws && setTimeout(createWs, constants.WS_RECONNECTION_INTERVAL);
                    ws = null;
                } else {
                    emitter(END);
                }
            };
            ws.onerror = () => {
                ws && emitter(wsDisconnected());
                if (canceled === false) {
                    ws && setTimeout(createWs, constants.WS_RECONNECTION_INTERVAL);
                    ws = null;
                } else {
                    emitter(END);
                }
            };
        }
        setTimeout(createWs, 0);
        return () => {
            canceled = true;
            ws && ws.close();
        };
    });
}

function* openWs() {
    const chan = yield call(createEventChannel);
    try {
        while (true) {
            const action = yield take(chan);
            yield put(action);
        }
    } finally {
        if (yield cancelled()) {
            chan.close();
        }
    }
}

export default function* root() {
    while (yield take(constants.AUTH_LOGIN_SUCCESS)) {
        const wsTask = yield fork(openWs);
        yield take(constants.AUTH_LOGOUT);
        yield cancel(wsTask);
    }
}
